// extracted by mini-css-extract-plugin
export default {"base":"DashboardHeader_base__Jho28","titlePanel":"DashboardHeader_titlePanel__99OBu"};